import React, { useCallback, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Form, Image, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { VendorDepartmentStructure, VendorDepartmentUserStructure, VendorStructure } from "../types/type";
import { api_url } from "../api/config/config";

const Account: React.FC = () => {

    const [selectedOption, setSelectedOption] = useState<string>('');
    const navigate = useNavigate();
    const { userInfo, userToken, error: userError } = useSelector((state: RootState) => state.auth);
    const { vendorInfo, loading: vendorLoading, error: vendorError } = useSelector((state: RootState) => state.vendor);
    const [vendorDepartmentInfo, setVendorDepartmentInfo] = useState<VendorDepartmentStructure[]>([]);
    const [fetching, setFetching] = useState<boolean>(false);

    const handleMenuSelectChange = (menuOption: string) => {
        setSelectedOption(menuOption);
        if (menuOption) {
            navigate(menuOption);
        }
    };

    function renderUserRole(userRole: string) {
        switch (userRole) {
            case "system_admin":
            case "client_admin":
            case "vendor_admin":
                return <span className="bg-red-04 text-white bg-color-text">管理者</span>;
            case "vendor_manager":
                return <span className="bg-blue-04 text-white bg-color-text">責任者</span>;
            default:
                return <span className="bg-green-01 text-white bg-color-text">一般 </span>;
        }
    }

    const fetchVendorInfo = useCallback(async () => {
        setFetching(true);
        try {
            const id = vendorInfo?.vendor_id;
            const response = await fetch(`${api_url}/getVendorById`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    vendor_id: id,
                    userToken
                }),
            });

            const res = await response.json();
            const vendor: VendorStructure = res.data;
            setVendorDepartmentInfo(vendor.vendor_departments);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setFetching(false);
        }
    }, [userToken, vendorInfo?.vendor_id])

    useEffect(() => {
        fetchVendorInfo();
    }, [fetchVendorInfo])

    const countUsers = (departments: any[]) => {
        if (!departments || departments.length === 0) {
            return 0;
        }
        return departments.reduce((total: any, department: { users: string | any[]; }) => total + department.users.length, 0);
    };

    return (
        <>

            <section className="section-table-theme user-management">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 order-lg-2 text-right">
                            <div className="text-lg-end text-start">
                                <Image className="height-30 mb-3 d-inline-block me-2" src="assets/images/other/icon-users.svg" />
                                <div className="text-md fw-400 d-inline-block">
                                    全
                                    <span className="text-xl text-blue-04 fw-300 mx-2">{countUsers(vendorDepartmentInfo)}</span>アカウント 表示中
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <Form.Group className="search-wrapper form-theme">
                                <Form.Label htmlFor="customSelect">管理メニュー</Form.Label>
                                <Form.Select
                                    className="custom-select theme-form-select text-theme ms-2"
                                    id="menu"
                                    onChange={(e) => handleMenuSelectChange(e.target.value)}
                                    value={selectedOption} >
                                    <option value="">選択してください</option>
                                    <option value="/reset_password">パスワード変更</option>
                                    <option value={'/account_edit?id=' + userInfo?.id}>マイアカウント情報変更</option>

                                    {
                                        vendorInfo?.role == "vendor_admin" ? <>
                                            <option value="/account_add">新規ユーザー追加</option>
                                            <option value="/vendor_edit">企業情報変更</option>
                                        </> : ''
                                    }

                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="table-responsive overflow-y-unset mb-lg-5 mb-4 tableFixHead">
                        <table className="table table-borderless table-theme table-vertical-align-middle table-fixed">
                            <thead>
                                <tr>
                                    <th style={{ width: '100px' }} className=""></th>
                                    <th style={{ width: '200px' }} className="text-start w-min-170 fw-300">氏名</th>
                                    <th style={{ width: '200px' }} className=" text-start fw-300">部署名</th>
                                    {/* <th style={{ width: '170px' }} className="w-min-250 text-start fw-300">部署名</th> */}
                                    <th style={{ width: '200px' }} className="text-end fw-300">役職</th>
                                    <th style={{ width: '100px' }} className="text-end fw-300">応札件数</th>
                                    {/* <th className="text-end fw-300">落札件数</th> */}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* ここでスピナー表示 */}
                                {fetching ? (
                                    <tr>
                                        <td colSpan={6} className="text-center py-5">
                                            <Spinner animation="border" role="status" variant="primary">
                                                <span className="visually-hidden"></span>
                                            </Spinner>
                                        </td>
                                    </tr>
                                ) : (
                                    vendorDepartmentInfo && vendorDepartmentInfo.map((dept, index) =>
                                        dept.users.map((user, userIndex) => (
                                            <tr key={`${index}-${userIndex}`} className="border-bottom">
                                                <td style={{ width: '100px' }}>{renderUserRole(user.role)}</td>
                                                <td style={{ width: '200px' }} className="text-start w-min-170 fw-300">{user.last_name}　{user.first_name}</td>
                                                <td style={{ width: '200px' }} className="text-start fw-300">{dept.name}</td>
                                                {/* <td style={{ width: '170px' }} className="w-min-250 text-start fw-300">{dept.name}</td> */}
                                                <td style={{ width: '200px' }} className="text-end fw-300">{user.title}</td>
                                                <td style={{ width: '100px' }} className="text-end fw-300"><span className="text-blue-deep-theme">{user.tender_count ?? 0}</span></td>
                                                {/* <td className="text-end fw-300"><span className="text-blue-deep-theme">0</span></td> */}
                                                <td style={{ width: '170px' }} className="text-end">
                                                    {
                                                        (vendorInfo?.role === "vendor_admin") ? (
                                                            <a href={`/account_edit?id=${user.id}`} className="btn text-blue-deep-theme">編集</a>
                                                        ) : null
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Account;